import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { DocumentSearchDataState } from "@us/Store/Data/DocumentSearchDataState";
import { DocumentSearchPageParameterModel } from "@us/Store/Data/DocumentSearchPage/DocumentSearchPageState";
import { Draft } from "immer";

const initialState: DocumentSearchDataState = {
    isLoading: false,
    documentSearchdata: null,
    pagination: null,
};

const pagination: DocumentSearchPageParameterModel = {
    initialDocumentTypes: "",
    query: "",
    searchCategoryFilter: "",
    sort: "",
    page: 0,
    pageSize: 0
}

const reducer = {
    "Custom/DocumentSearchData/SetDocumentSearchData": (
        draft: Draft<DocumentSearchPageParameterModel>,
        action: { result: DocumentSearchPageParameterModel },
    ) => {
        draft.page = action.result.page;
        draft.initialDocumentTypes = action.result.initialDocumentTypes;
        draft.pageSize = action.result.pageSize;
        draft.sort = action.result.sort;
        draft.query = action.result.query;
        draft.searchCategoryFilter = action.result.searchCategoryFilter;
    },
};

export default createTypedReducerWithImmer(pagination, reducer);